import React from 'react';
import PropTypes from 'prop-types';
import { css } from '@emotion/core';
import styled from '@emotion/styled';

import Icon from './Icon';

const iconContainerBaseStyles = ({ theme }) => css`
  border-radius: ${theme.borderRadius.circle};
  background-color: ${theme.colors.red};
  color: ${theme.colors.white};
  width: 20px;
  height: 20px;

  svg {
    width: 100% !important;
    height: 100% !important;
    padding: ${theme.spacings.bit};
  }
`;
const iconContainerLiteStyles = ({ theme, variant }) =>
  variant === 'lite' &&
  css`
    background-color: ${theme.colors.white};
    border: 1px solid ${theme.colors.g700};
    color: ${theme.colors.g700};
  `;

const IconContainer = styled('div')(iconContainerBaseStyles, iconContainerLiteStyles);

const CheckCircle = ({ variant }) => (
  <IconContainer variant={variant}>
    <Icon icon='check' />
  </IconContainer>
);

CheckCircle.propTypes = {
  variant: PropTypes.string,
};

export default CheckCircle;
